<template>
    <v-row>
        <v-col class="calendar">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                :return-value.sync="displayDate" transition="scale-transition"  offset-y min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="date" :value="displayDate" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker @change="setDate" locale="ko-KR" v-model="date" no-title scrollable>
                </v-date-picker>
            </v-menu>
        </v-col>
        <v-col class="calendar time">
            <v-menu  ref="menu" v-model="menu2" :close-on-content-click="false"
                :nudge-right="40" :return-value.sync="time" transition="scale-transition" offset-y
                max-width="290px" min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="time" :value="displayTime"  readonly  v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-time-picker @change="setDate" v-if="menu2"  v-model="time" full-width @click:minute="$refs.menu.save(time)"></v-time-picker>
            </v-menu>
        </v-col>
    </v-row>
</template>

<script>
    export default {
    data() {
        return {
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            displayDate: '',
            displayTime: '',
            menu: false,
            menu2: false,
            time: null,
            modal: false,
            modal2: false,
        }
    },
    
    mounted() {
        
    },

    watch: {
        sDateTime() {
            this.date = this.sDateTime.sDate;
            this.time = this.sDateTime.sTime;
        },
        eDateTime() {
            this.date = this.eDateTime.eDate;
            this.time = this.eDateTime.eTime;
        },
    },

    methods : {
        setDate() {
            if(this.sDateTime == undefined) {
                this.eDateTime.eDate = this.date;
                this.eDateTime.eTime = this.time;
                this.$emit('emitEDate', this.eDateTime);
            }else {
                this.sDateTime.sDate = this.date;
                this.sDateTime.sTime = this.time;
                this.$emit('emitSDate', this.sDateTime);
            }
        }
    },

    props: {
        sDateTime : {
            sDate: String, 
            sTime: String},
        eDateTime : {
            eDate: String, 
            eTime: String}
    }
    
    }
</script>